import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Layout } from "@/components/Layout";
import api from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { MapPin, ArrowRight } from "@phosphor-icons/react";

export default function Directory() {
  const [states, setStates] = useState(null);
  useEffect(() => {
    api.get("/directory/states").then((r) => setStates(r.data)).catch(() => setStates([]));
  }, []);
  useSeo({
    title: "Dry ice blasting pros, by state · Dry Ice Connect",
    description: "Browse verified dry ice blasting contractors across every US state. Mobile and in-shop services for automotive, industrial, marine, restoration and food-safe cleaning.",
    canonical: `${window.location.origin}/pros`,
  });

  return (
    <Layout>
      <section className="bg-grid bg-grid-fade border-b border-[#262626]">
        <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-16 lg:py-24">
          <div className="section-label mb-3">— US DIRECTORY</div>
          <h1 className="font-chivo font-black text-4xl sm:text-5xl lg:text-7xl text-white uppercase tracking-tighter leading-none" data-testid="directory-headline">
            Dry ice blasting pros.
            <br /><span className="text-[#00D4FF]">By state. By city.</span>
          </h1>
          <p className="font-plex text-lg text-[#9CA3AF] mt-6 max-w-2xl">
            Every verified contractor on Dry Ice Connect, grouped by state and city. Click into any state to see which cities we cover.
          </p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 lg:px-8 py-12">
        <div className="section-label mb-5">— STATES WITH VERIFIED PROS</div>
        {!states ? (
          <div className="font-mono text-xs text-[#52525B]">[LOADING]</div>
        ) : states.length === 0 ? (
          <div className="surface p-10 text-center">
            <MapPin size={36} weight="duotone" className="text-[#00D4FF] mx-auto mb-2" />
            <div className="font-chivo font-bold text-white uppercase">No approved listings yet</div>
            <p className="font-plex text-sm text-[#9CA3AF] mt-2">Our verified network is spinning up. Check back soon.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="directory-states">
            {states.map((s) => (
              <Link
                key={s.state}
                to={`/pros/${s.state_slug}`}
                className="surface surface-hover p-5 group flex items-center justify-between"
                data-testid={`directory-state-${s.state_slug}`}
              >
                <div>
                  <div className="font-mono text-[10px] text-[#00D4FF] tracking-widest">{s.state}</div>
                  <div className="font-chivo font-bold text-white mt-1">{s.state_name}</div>
                  <div className="font-mono text-[11px] text-[#52525B] mt-1">{s.listing_count} pro{s.listing_count === 1 ? "" : "s"} · {s.city_count} cit{s.city_count === 1 ? "y" : "ies"}</div>
                </div>
                <ArrowRight size={16} className="text-[#52525B] group-hover:text-[#00D4FF]" weight="bold" />
              </Link>
            ))}
          </div>
        )}

        <div className="mt-10 surface p-8 flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
          <div>
            <div className="section-label mb-1">— OWN A BLASTING BUSINESS?</div>
            <div className="font-chivo font-bold text-white uppercase">Get listed on the map.</div>
          </div>
          <Link to="/pros/join" className="btn-primary text-xs" data-testid="directory-contractor-cta">Join The Network</Link>
        </div>
      </section>
    </Layout>
  );
}
